import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import Button from '../../../components/Button';
import backgroundImg from '../../../assets/hero-subsection-background.svg';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundImage: `url(${backgroundImg})`,
    padding: '6rem 1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '6rem 1.5rem',
    },
  },
  content: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  title: {
    width: '100%',
    textAlign: 'left',
    marginBottom: '1rem',
    color: theme.palette.common.white,
  },
  text: {
    marginBottom: '2rem',
    color: theme.palette.common.white,
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    padding: '1rem 2rem',
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    '&:hover': {
      borderColor: theme.palette.common.white,
      backgroundColor: 'rgba(256, 256, 256, .2)',
    },
  },
  link: {
    width: '100%',
    padding: '1rem 0',
    color: theme.palette.common.white,
    cursor: 'pointer',
    paddingLeft: '0.5rem',
  },
}));

const HeroSubSection = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container maxWidth="lg" fixed disableGutters>
        <Grid container>
          <Grid item md={9}>
            <div className={classes.content}>
              <Typography variant="h1" className={classes.title}>
                Try our new participant account features that help you manage your NDIS journey, <em>for free!</em>
              </Typography>
              <Typography variant="body2" className={classes.text}>
                At Clickability we&apos;re always looking for ways to make your life easier. We’ve just added a host of new features to our participant user accounts (like the ability to store, categorise and search your NDIS and provider documents!) so that you have one secure and smart place for all your important information. You can also view the details of any service requests you have made for providers through Clickability.
              </Typography>
              <Typography variant="body2" className={classes.text}>
                We’re not stopping here, with a lot more on the way. You can also use the feedback form in your account profile to tell us what would be most useful to you!
              </Typography>
              <div className={classes.buttons}>
                <Button
                  label="Log in to my account"
                  to="/login"
                  variant="outlined"
                  className={classes.button}
                />
                <Link component={RouterLink} to="/signup" className={classes.link}>
                  Join Clickability today
                </Link>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default HeroSubSection;
